import {HubspotFormHiddenField} from "@/types/hubspot/hubspot-form";

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2){
    return parts.pop()?.split(";").shift() ?? undefined;
  }
  return undefined;
};

export const buildContext =(submissionValues : any, locale: string, clientId?: string, sessionId?: string, measurementId?: string) => {
  type Context = {
    hutk?: string;
    pageUri?: string;
    pageName?: string;
    ipAddress?: string;
    gaMeasurementId?: string;
    gaClientId?: string;
    gaSessionId?: string;
    locale?: string;
  };
  
  const hsContext = JSON.parse(submissionValues.hs_context);
  const context: Context = {};
  context.hutk = getCookie("hubspotutk");
  context.pageUri = hsContext.pageUrl;
  context.pageName = hsContext.pageTitle;
  context.ipAddress = "::ffff:10.131.52.17";
  context.gaMeasurementId = measurementId ?? undefined;
  context.gaClientId = clientId ?? undefined;
  context.gaSessionId = sessionId ?? undefined;
  context.locale = locale ?? undefined;
  return context;
};

export const fieldObjectToJsonArray = (fieldObject: any) =>
  Object.keys(fieldObject).map(key => ({
    name: key,
    value: fieldObject[key]?.toString()
  }));

export const prepareFields = (submissionValues : any) => {
  const fields = JSON.parse(JSON.stringify(submissionValues));
  delete fields.hs_context;
  Object.keys(fields).forEach(key => {
    if (key.startsWith("LEGAL_CONSENT")) {
      delete fields[key];
    }
  });
  return fieldObjectToJsonArray(fields);
};
export interface SubmissionData {
  submittedAt: number;
  fields: any;
  context: any;
  portalId: any;
  formId: any;
}

export const prepareFormDataSubmitted = (submissionValues: any, portalId: string, formId: string, locale:string, leadServiceOnlyFields?: HubspotFormHiddenField[], clientId?: string, sessionId?: string, measurementId?: string) => {
  if (leadServiceOnlyFields) {
    leadServiceOnlyFields.forEach(({ id, value }) => {
      // eslint-disable-next-line no-param-reassign
      submissionValues[id] = value;
    });
  }
  const submissionData: SubmissionData = {
    submittedAt: Date.now(),
    fields: prepareFields(submissionValues),
    context: buildContext(submissionValues, locale, clientId, sessionId, measurementId),
    portalId: portalId || "2641890", // Default to Collette's portal ID if not provided
    formId
  };
  return submissionData;
};
